import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { partnerStore } from '@/stores/partnerStore'
import { memberStore } from '@/stores/memberStore'
import { issueStore } from '@/stores/issueStore'
import { configStore } from '@/stores/configStore'
import './app.scss'
import axios from 'axios'
import globals from './globals'
import { identifyUser } from '@/services/memberService'
import chatService from '@/services/chatService'
import { chatStore } from './stores/chatStore'
import { getConfig } from '@/api/providersApi'
import { getAgentConfig } from '@/api/chatDemoApi'

// todo move this...somewhere
let url = new URL(window.location.href)
let initParam = JSON.parse(url.searchParams.get('init') || '{}')
let parentOrigin
if (
  initParam &&
  initParam.parentOrigin &&
  initParam.integrationId &&
  initParam.partnerToken &&
  initParam.partnerTeam &&
  (initParam.chatSource !== 'bot' || initParam.botURL)
) {
  parentOrigin = initParam.parentOrigin
  axios.defaults.headers.common = {
    'X-Boomtown-Token': initParam.partnerToken,
    'X-Boomtown-Date': new Date().toISOString(),
  }
  partnerStore.setConfig(initParam)
  configStore.setConfig('embedded', Boolean(initParam.parentElement))
  if (initParam.chatSource) {
    chatStore.setChatSource(initParam.chatSource)
    configStore.setConfig('chatSource', initParam.chatSource)
    configStore.setConfig('showEscalateButton', initParam.showEscalateButton === false ? false : true)
  }
  if (initParam.botURL) {
    globals.apiHostBot = initParam.botURL
    // Fetch agent config if botURL is present
    getAgentConfig()
      .then(agentData => {
        if (agentData) {
          console.log('Agent config loaded:', agentData)
          partnerStore.setAgentInfo(agentData)
        }
      })
      .catch(error => {
        console.error('Failed to load agent config:', error)
      })
  }
} else {
  throw new Error('Missing Config Data')
}

window.addEventListener('message', async event => {
  var message
  if (initParam.parentOrigin && event.origin === initParam.parentOrigin) {
    message = JSON.parse(event.data)
    switch (message.type) {
      case 'identifyUser':
        if (!chatService.client) {
          identifyUser(message.user)
        }
        break
      case 'navigateToScreen':
        if (message.path) router.push(message.path)
        if (message.name) {
          router.push({
            name: message.name,
            id: '',
            query: message.query,
          })
        }
        break
      case 'updateAppOpen':
        configStore.setConfig('appOpen', message.value)
        
        if (message.value === true) {
          try {
            const config = await getConfig()
            console.log('config', config)
            partnerStore.setConfig(config)
          } catch (error) {
            console.error('Error refreshing provider config:', error)
          }
          
          window.sessionStorage.setItem(
            `${initParam.integrationId}.app-open`,
            1,
          )
        } else {
          window.sessionStorage.removeItem(
            `${initParam.integrationId}.app-open`,
          )
        }
        break
      case 'setHideWelcomeMessage':
        window.sessionStorage.setItem(
          `${initParam.integrationId}.welcome-hidden`,
          1,
        )
        break
      case 'updateScreenSize':
        configStore.setConfig('fullScreen', message.value < 460)
        break
      case 'resetApp':
        memberStore.unsetMember()
        issueStore.unsetIssue()
        sessionStorage.clear()
        break
      case 'sourceURL':
        configStore.setConfig('sourceURL', message.sourceURL)
        break
      default:
        break
    }
  }
})

document.addEventListener('keydown', event => {
  if (event.key === 'Escape') {
    window.parent.postMessage(
      JSON.stringify({ type: 'closeApp' }),
      partnerStore.config.parentOrigin,
    )
  }
})

globals.parentOrigin = parentOrigin

if (initParam.apiHost) {
  if (initParam.apiHost === 'local-stage') {
    // will get proxied to stage by local dev server
    globals.apiHost = '/api-stage'
  } else if (initParam.apiHost === 'local-prod') {
    globals.apiHost = '/api-prod'
  } else {
    globals.apiHost = initParam.apiHost + '/api/v2'
  }
} else {
  globals.apiHost = location.host.match(/goboomtown/)
    ? 'https://api' + window.location.host.split('messenger')[1] + '/api/v2'
    : 'https://api.goboomtown.com/api/v2'
}

if (initParam.filesServiceURL) {
  globals.apiHostFiles = initParam.filesServiceURL
} else if (initParam.apiHost && initParam.apiHost !== 'local-stage' && initParam.apiHost !== 'local-prod') {
  globals.apiHostFiles = initParam.apiHost + '/files'
} else if (location.host.match(/stage-ovationcxm/)) {
  globals.apiHostFiles = 'https://api.stage-ovationcxm.app/files'
} else if (location.host.match(/preprod-ovationcxm/)) {
  globals.apiHostFiles = 'https://api.preprod-ovationcxm.app/files'
} else if (location.host.match(/ovationcxm/)) {
  globals.apiHostFiles = 'https://api.ovationcxm.app/files'
} else {
  globals.apiHostFiles = 'https://api.stage-ovationcxm.app/files'
}

const app = createApp(App)
app.use(router)
app.mount('#app')
